var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from "react";
import { observer } from "mobx-react";
import { Container, Content, Expired, Num, BoxSymbol } from "./styles";
import ImageView from "../../../components/SmartImage";
import { getLitbLangFn } from "../../../utils/language";
import { endUnit, EnFormateDays, formatDate, formatMinutesAndSeconds } from "../../../utils/time";
import { CountdownStore } from "./store";
import { TActState } from "../../../services/banner";
import { formatAspect } from "../../../utils/banner";
import { isValidState, isUnValidState } from "../../../utils/banner";
let CountDownBanner = class CountDownBanner extends React.Component {
    constructor(props) {
        super(props);
        this.store = new CountdownStore(props.actState, props.timer, props.onRefresh);
    }
    componentWillUnmount() {
        clearInterval(this.store.intervalId);
    }
    get title() {
        const { state, timer, countDown } = this.store;
        const { language } = this.props;
        switch (state) {
            case TActState.ComingSoon:
                return `${getLitbLangFn("Starts On", language)} ${formatDate(parseInt(timer === null || timer === void 0 ? void 0 : timer.start, 10) * 1000, language)}`;
            case TActState.OnGoing:
                return `Ends In ${EnFormateDays(countDown)} ${endUnit(language)}`;
            default:
                return `${getLitbLangFn("We‘re sorry，the offer has expired.", language)}`;
        }
    }
    render() {
        const { positionId, banner, placeholderBg } = this.props;
        const { state, countDown } = this.store;
        const validBannerStatus = isValidState(state);
        const bannerHeight = banner.height && validBannerStatus ? banner.height : "auto";
        const width = formatAspect(banner.width || "");
        return (React.createElement("section", { "data-id": positionId, id: positionId },
            React.createElement(Container, { style: { height: `${bannerHeight}` } },
                isUnValidState(state) && React.createElement(Expired, null, this.title),
                validBannerStatus && (React.createElement(React.Fragment, null,
                    React.createElement(ImageView, { src: banner === null || banner === void 0 ? void 0 : banner.img, online: true, qnParams: { w: Math.max(width, 750) }, placeholder: placeholderBg, fallbackSrc: placeholderBg, style: {
                            width: "100%",
                        } }),
                    React.createElement(Content, null,
                        React.createElement("h1", null, this.title),
                        React.createElement("div", null, formatMinutesAndSeconds(countDown, state).map((item, index) => {
                            return (React.createElement(React.Fragment, { key: `${index}` },
                                item.split("").map((i, idx) => (React.createElement(Num, { key: `${idx}_${i}` }, i))),
                                !!(index < 2) && React.createElement(BoxSymbol, null, ":")));
                        }))))))));
    }
};
CountDownBanner = __decorate([
    observer
], CountDownBanner);
export default CountDownBanner;
